export default __webpack_public_path__ + "static/media/logo.567466cf.png";